import { VueRegistration } from "@abaco/web-common/src/app";

const globals: VueRegistration = {
    "EtlPrintsIframe": () => import("./componentsOld/tiles/EtlPrintsIframe.vue"),
    "EtlImportExportIframe": () => import("./componentsOld/tiles/EtlImportExportIframe.vue"),
    "EtlImportExportBoIframe": () => import("./componentsOld/tiles/EtlImportExportBoIframe.vue"),
    "EtlImportExportEnterpriseIframe": () => import("./componentsOld/tiles/EtlImportExportEnterpriseIframe.vue"),
    "EtlPrintsTileContainer": () => import("./componentsOld/EtlPrintsTileContainer.vue"),
    "EtlImportExportTileContainer": () => import("./componentsOld/EtlImportExportTileContainer.vue"),
    "EtlImportExportBoTileContainer": () => import("./componentsOld/EtlImportExportBoTileContainer.vue"),
    "EtlImportExportEnterpriseTileContainer": () => import("./componentsOld/EtlImportExportEnterpriseTileContainer.vue")
};

export default globals;
